import 'cross-fetch/polyfill';

export function fetchText(url, options = {}) {
    return fetch(url, options)
        .then(res => checkFetchStatus(res))
        .then(res => res.text());
}

export function fetchJson(url, options?, jsonResponse = true): Promise<any | HttpError> {
    options = options || {};
    // Ensure headers are initialized properly
    options.headers = options.headers || new Headers();
    // Setting the 'Content-Type' header
    options.headers.set('Content-type', 'application/json');

    return fetch(url, options)
        .then(res => checkFetchStatus(res))
        .then(res => jsonResponse ? res.json() : res.text());
}

export function checkFetchStatus(res) {
    if (res.status >= 200 && res.status < 300) {
        return res;
    } else {
        const error = new HttpError(res.statusText);
        error.response = res;
        throw error;
    }
}

export class HttpError extends Error {
    response;

    constructor(message) {
        super(message);
        this.name = "HttpError";
    }
}
